module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../lodash/first.js
// module id = 1255
// module chunks = 25